import PropTypes from "prop-types";

const CardDetailsView = ({ title, value, customClassName }) => (
  <div className={`tw-flex tw-gap-[8px] tw-items-baseline  ${customClassName}`}>
    <span className="tw-text-[12px] tw-text-gray-50 tw-font-semibold">{title}:</span>
    {value && (
      <span className="tw-text-[12px] tw-font-semibold tw-text-gray-75 tw-max-h-[200px] tw-whitespace-pre-wrap tw-break-words tw-overflow-y-auto tw-overflow-x-hidden">
        {value}
      </span>
    )}
  </div>
);

CardDetailsView.propTypes = {
  customClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
CardDetailsView.defaultProps = {
  customClassName: "",
};

export default CardDetailsView;
